export default {
	signUp: 'ALS NEUKUNDE BUCHEN',
	password: 'Wir senden Ihnen ein Passwort an Ihre E-Mail-Adresse',
	youHaveRegistered: 'Sie haben sich erfolgreich registriert!',
	checkEmail: email => `Wir haben die Anmeldeparameter dupliziert zu Ihrer E-Mail (${email})`,
	passportPhoto: 'Passfoto (letzte Seite)',
	selfieWithPassport: 'Ihr Selfie mit der letzten Seite des Reisepasses',
	legalDocumentPhoto: 'Foto der legalen Einreiseregistrierung'
};
